import getNode from './default.js';

export default {
    getNode
};
